import axios, { AxiosResponse } from "axios";
import { convertToPageable, downloadFileWithPresignedUrl, handleApiException, handleResponse } from "helpers/apiResponseHelper";
import { IElectricityInvoiceRequest } from "models/electricity/electricity-invoice";
import { apiService } from "services/api.service";

async function getInvoices(customerId: number, pageRequest: IElectricityInvoiceRequest) {
  return axios.get(apiService.getApiUrl() + `/electricity/invoices/customer/${customerId}`,
      {
          params: pageRequest
      }).then(handleResponse).then(convertToPageable).catch(handleApiException);
}

async function getInvoiceFile(invoiceId: number, filename?: string) : Promise<AxiosResponse<string>>{
  return axios.get(`${apiService.getApiUrl()}/electricity/invoices/${invoiceId}/file?downloadAs=${filename}`)
    .then(handleResponse).catch(handleApiException);
}

async function getInvoiceFileWithDownload(invoiceId: number, filename: string) {
  return getInvoiceFile(invoiceId, filename).then(res => downloadFileWithPresignedUrl(res.data));
}

const ElectricityInvoiceService = {
  getInvoices,
  getInvoiceFile,
  getInvoiceFileWithDownload
};

export default ElectricityInvoiceService;